import { Calendar, CalendarProps, DateLocalizer, dayjsLocalizer, Views } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './BaseCalendar.scss';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';

type BaseCalendarProps = Omit<CalendarProps, 'localizer'> & {
  localizer?: DateLocalizer;
};

const localizer = dayjsLocalizer(dayjs);

const BaseCalendar = (props: BaseCalendarProps) => {
  const {
    views = {
      month: true,
      week: true,
      day: true,
    },
    formats = {
      dateFormat: 'D',
      weekdayFormat: 'dddd',
      dayFormat: 'dddd',
      timeGutterFormat: 'h A',
    },
    ...restProps
  } = props;

  const [view, setView] = useState(restProps.view || Views.MONTH);
  const [date, setDate] = useState(restProps.date || dayjs().toDate());

  const onView = useCallback((newView: any) => setView(newView), [setView]);

  useEffect(() => {
    if (props.view) setView(props.view);
  }, [props.view]);

  useEffect(() => {
    if (props.date) setDate(props.date);
  }, [props.date]);

  return (
    <>
      <Calendar
        localizer={localizer}
        startAccessor='start'
        endAccessor='end'
        style={{ height: '100%' }}
        views={views}
        view={view}
        onView={onView}
        date={date}
        onNavigate={setDate}
        formats={formats}
        {...restProps}
      />
    </>
  );
};

export default BaseCalendar;
